import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

import AgeGate from '@/views/AgeGate'
import MainContainer from '@/views/MainContainer'
import UnlockContainer from '@/views/UnlockContainer'

Vue.use(Router)

/**
 * @typedef {import('vue-router').Location} RouterLocation
 */


/**
 * Redirects users to age-gate if they didn't answer yet.
 * @param {RouterLocation} to
 * @param {RouterLocation} from
 * @param {Function} next
 */
function checkAge (to, from, next) {
  try {
    store.dispatch('checkAge')
    next()
  } catch (err) {
    next({
      name: 'age-gate',
      query: { redirect: to.fullPath },
    })
  }
}

/**
 * Redirects to / if the game wasn't unlocked yet.
 * @param {RouterLocation} to
 * @param {RouterLocation} from
 * @param {Function} next
 */
async function checkGameUnlocked (to, from, next) {
  try {
    await store.dispatch('checkGameUnlocked', to.params['id'])
    next()
  } catch (err) {
    next('/')
  }
}

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'main',
      beforeEnter: checkAge,
      redirect: '/unlock',
      component: MainContainer,
      children: [
        {
          path: 'unlock',
          name: 'unlock',
          redirect: '/unlock/landing',
          component: UnlockContainer,
          meta: { title: 'Landing Page' },
          children: [
            {
              path: 'landing',
              name: 'unlock-landing',
              component: () =>
                import(/* webpackChunkName: "unlock-landing" */ '@/views/UnlockLanding.vue'), // eslint-disable-line
            },

            {
              path: 'home',
              name: 'unlock-home',
              redirect: '/games',
              meta: { title: 'Home Page' },
              component: () =>
                import(/* webpackChunkName: "unlock-home" */ '@/views/UnlockHome.vue'), // eslint-disable-line
            },

            {
              path: 'riddle',
              name: 'unlock-riddle',
              redirect: '/games',
              meta: { title: 'Unlock Page' },
              component: () =>
                import(/* webpackChunkName: "unlock-riddle" */ '@/views/UnlockRiddle.vue'), // eslint-disable-line
            },

            {
              path: 'games',
              name: 'unlock-games',
              redirect: '/games',
              meta: { title: 'Games Page' },
              component: () =>
                import(/* webpackChunkName: "unlock-games" */ '@/views/UnlockGames.vue'), // eslint-disable-line
            },
          ],
        },

        {
          path: 'games',
          name: 'game-selection',
          meta: { title: 'Previously Unlocked Games' },
          component: () =>
            import(/* webpackChunkName: "game-home" */ '@/views/GameSelection.vue'), // eslint-disable-line
        },

        {
          path: 'game/:id',
          name: 'game',
          beforeEnter: checkGameUnlocked,
          meta: { title: {
            toString () {
              const id = router.currentRoute.params['id']
              const game = store.getters.gameWithId(id)
              return `Game - ${game.name}`
            },
          } },
          component: () =>
            import(/* webpackChunkName: "game-home" */ '@/views/GameHome.vue'),
        },
      ],
    },
    {
      path: '/confirm-age',
      name: 'age-gate',
      component: AgeGate,
      meta: { title: 'Age Gate' },
    },

    {
      path: '/*',
      redirect: '/',
    },
  ],
})

export default router
